/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_SubtitleInputs */

const en_pc_online_subtitle = /** @type {(inputs: Pc_Online_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The PdfCraft app compiled to WebAssembly, running in this page. Click inside the window and drop in a PDF.`)
};

const zh_pc_online_subtitle = /** @type {(inputs: Pc_Online_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编译为 WebAssembly 的 PdfCraft 应用，就在本页中运行。点击窗口内部，然后拖入一个 PDF。`)
};

/**
* | output |
* | --- |
* | "The PdfCraft app compiled to WebAssembly, running in this page. Click inside the window and drop in a PDF." |
*
* @param {Pc_Online_SubtitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_subtitle = /** @type {((inputs?: Pc_Online_SubtitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_SubtitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_subtitle(inputs)
	return zh_pc_online_subtitle(inputs)
});
export { pc_online_subtitle as "pc.online.subtitle" }